import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { RouterModule } from "@angular/router";
import { CrearTipoClienteComponent } from "./crear-tipo-cliente/crear-tipo-cliente.component";
import { CrearTipoClienteDialog } from "./crear-tipo-cliente/crear-tipo-cliente-dialog/crear-tipo-cliente-dialog.component";
import { EditarTipoClienteComponent } from "./editar-tipo-cliente/editar-tipo-cliente.component";
import { EditarTipoClienteDialog } from "./editar-tipo-cliente/editar-tipo-cliente-dialog/editar-tipo-cliente-dialog.component";
import { EliminarTipoClienteComponent } from "./eliminar-tipo-cliente/eliminar-tipo-cliente.component";
import { EliminarTipoClienteDialog } from "./eliminar-tipo-cliente/eliminar-tipo-cliente-dialog/eliminar-tipo-cliente-dialog.component";
import { IrTipoClienteComponent } from "./ir-tipo-cliente/ir-tipo-cliente.component";
import { TipoClienteComponent } from "./tipo-cliente/tipo-cliente.component";
import { TipoClienteService } from "./tipo-cliente/tipo-cliente.service";
import { VerTiposClienteComponent } from "./ver-tipos-cliente/ver-tipos-cliente.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        RouterModule,
    ],
    declarations: [
        CrearTipoClienteComponent,
        CrearTipoClienteDialog,
        EditarTipoClienteComponent,
        EditarTipoClienteDialog,
        EliminarTipoClienteComponent,
        EliminarTipoClienteDialog,
        IrTipoClienteComponent,
        TipoClienteComponent,
        VerTiposClienteComponent,
    ],
    providers: [
        TipoClienteService,
    ],
    entryComponents: [
        CrearTipoClienteDialog,
        EditarTipoClienteDialog,
        EliminarTipoClienteDialog,
    ],
    exports: [
        CrearTipoClienteComponent,
        EditarTipoClienteComponent,
        EliminarTipoClienteComponent,
        IrTipoClienteComponent,
        TipoClienteComponent,
        VerTiposClienteComponent,
    ]
})
export class TipoClienteModule { }